module.exports = {
  "es-CO": {
    "LANGUAGE_NATIVE_NAME": "Inglés"
  }
};